import { render, staticRenderFns } from "./HotRecommendation.vue?vue&type=template&id=2d518227&scoped=true&"
import script from "./HotRecommendation.vue?vue&type=script&lang=js&"
export * from "./HotRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./HotRecommendation.vue?vue&type=style&index=0&id=2d518227&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d518227",
  null
  
)

export default component.exports